module.exports = __webpack_public_path__ + "static/media/logo-light.bf99de1d.svg";